<template>
  <div>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-5">
                    <h4 class="card-title mb-0">
                      Pending to Accept Order Management <small class="text-muted"> orders</small>
                    </h4>
                </div><!--col-->

                <div class="col-sm-7">
                    <!-- <header-button></header-button> -->
                </div><!--col-->
            </div><!--row-->
            <hr />
            <div class="row mt-4">
              <div class="col-sm-6">
                <h5 class="mb-3">{{ $t('marketplace.order.filter_option') }}</h5>
                <b-form v-if="show">
                  <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ $t('marketplace.order.created_order_date') }}</label>
                    <div class="col-sm-9 row">
                      <div class="col-sm-6 form-row">
                        <datepicker v-model="filter.createdDateFrom" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
                      </div>
                      <div class="col-sm-6 form-row">
                        <datepicker v-model="filter.createdDateTo" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
                      </div>
                    </div>
                  </div>
                  <b-form-fieldset
                    :label="$t('marketplace.order.platform_order_id')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.platformOrderId" :placeholder="$t('marketplace.order.please_enter_platform_order_id')"></b-form-input>
                  </b-form-fieldset>
                  <b-form-fieldset
                    :label="$t('marketplace.order.platform')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select v-model="filter.platform" :options="platformOptions" />
                  </b-form-fieldset>
                  <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('marketplace.order.search') }}</b-button>
                  <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('marketplace.order.reset') }}</b-button>
                  <b-button type="button" size="sm" v-if="pendingOrders.length > 0" variant="success ml-1" @click="checkPendingAcceptOrders"><i class="fa fa-edit"></i> Retry Accept Platform Order</b-button>
                </b-form>
              </div><!--col-->
            </div>
            <div class="row mt-4">
                <div class="col">
                    <div class="table-responsive">
                        <table class="table">
                          <colgroup>
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="10%">
                          </colgroup>
                          <thead>
                            <tr>
                              <th>{{ $t('marketplace.order.platform') }}</th>
                              <th>{{ $t('marketplace.order.platform_order_id') }}</th>
                              <th>{{ $t('marketplace.order.platform_order_status') }}</th>
                              <th>{{ $t('marketplace.order.status') }}</th>
                              <th>{{ $t('marketplace.order.updated_at') }}</th>
                              <th>{{ $t('marketplace.order.operation') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(pendingOrder, index) in pendingOrders" :key="index">
                              <td>{{ pendingOrder.platform }}</td>
                              <td>{{ pendingOrder.platform_order_id }}</td>
                              <td>{{ pendingOrder.platform_order_status }}</td>
                              <td v-html="pendingOrder.status_label"></td>
                              <td>{{ pendingOrder.updated_at }}</td>
                              <td>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row">
                          <div class="col-sm-12 col-md-5">
                            <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                          </div>
                          <div class="col-sm-12 col-md-7">
                            <nav>
                              <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                            </nav>
                          </div>
                        </div>
                    </div>
                </div><!--col-->
            </div><!--row-->
        </div><!--card-body-->
    </div><!--card-->

  </div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'pendingOrders',
  components: {
    datepicker
  },
  mounted () {
    this.axios.get('/marketplace/order/pending-accept').then(response => {
      this.pendingOrders = response.data
      this.meta = response.meta
    }).catch(error => {
      console.log(error)
    })
  },
  computed: {
  },
  data () {
    return {
      modalShow: false,
      displayEditStatus: [2, 4],
      pendingOrders: [],
      meta: [],
      filter: {
        createdDateFrom: '',
        createdDateTo: '',
        platformOrderId: '',
        platform: null,
      },
      platformOptions: [
        { value: null, text: 'Please select an platform', key: 'Please select an platform' },
        { value: 'priceminister', text: 'Priceminister' },
        { value: 'fnac', text: 'Fnac' },
        { value: 'cdiscount', text: 'Cdiscount' },
        { value: 'darty', text: 'Darty' },
        { value: 'phonehouse', text: 'Phone House' },
        { value: 'shopify', text: 'Shopify' }
      ],
      currentPage: 1,
      show: true
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.platformOrderId = ''
      this.filter.platform = null
      this.filter.createdDateFrom = null
      this.filter.createdDateTo = null
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    checkPendingAcceptOrders () {
      this.axios.post('/marketplace/order/check-accept', {
          platform_order_id: this.filter.platformOrderId,
          platform: this.filter.platform,
          date_from: this.filter.createdDateFrom,
          date_to: this.filter.createdDateTo,
        }).then(response => {
          console.log(response)
          window.location.reload()
        }).catch(error => {
          console.log(error)
          this.$swal({
            title: 'Error 500, Internal Server Error',
            icon: 'error'
          })
        })
    },
    onSearchForm () {
      this.axios.get('/marketplace/order/pending-accept', {
        params: {
          platform_order_id: this.filter.platformOrderId,
          platform: this.filter.platform,
          date_from: this.filter.createdDateFrom,
          date_to: this.filter.createdDateTo,
        }
      }).then(response => {
        this.pendingOrders = response.data
        this.meta = response.meta
        var vm = this
        response.data.forEach(function (marketplaceOrder) {
          vm.referenceNos.push(marketplaceOrder.id)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      // var url = 'crayola_sku=' + this.filterOption.crayolaSku + '&dc_sku=' + this.filterOption.dcSku + '&page=' + pageNum
      // required oninvalid="this.setCustomValidity('Please Enter valid email')"
      this.axios.get('/marketplace/order/pending-accept', {
        params: {
          platform_order_id: this.filter.platformOrderId,
          platform: this.filter.platform,
          date_from: this.filter.createdDateFrom,
          date_to: this.filter.createdDateTo,
          page: pageNum
        }
      }).then(response => {
        this.pendingOrders = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
